import { gql } from "@apollo/client";

const GET_CONEXIONES_CONTRATO = gql`
    query allConexionesContrato($idEvaluacion: Int!, $idPaciente: Int!) {
        allConexionesContrato(idEvaluacion: $idEvaluacion, idPaciente: $idPaciente) {
            idConexion
            idEvaluacion
            fechaConexion
            fechaAlta
            evaluacionFechaDesde
            evaluacionFechaHasta
            idEstado
            idUsuario
            usuario
            estado
        }
    }
`;

export default GET_CONEXIONES_CONTRATO;

export const adaptConexion = (conexion) => {
  return {
    idConexion: conexion?.idConexion,
    idEvaluacion: conexion?.idEvaluacion,
    fechaConexion: conexion?.fechaConexion,
    fechaAlta: conexion?.fechaAlta,
    evaluacionFechaDesde: conexion?.evaluacionFechaDesde,
    evaluacionFechaHasta: conexion?.evaluacionFechaHasta,
    idEstado: conexion?.idEstado,
    idUsuario: conexion?.idUsuario,
    usuario: conexion?.usuario,
    estado: conexion?.estado
  };
};

export const adaptConexionesArray = (conexionesContrato) => {
  return structuredClone(conexionesContrato)?.
  map((conexion) => adaptConexion(conexion));
};